// extracted by mini-css-extract-plugin
export default {"skill":"Skill_skill__2-MdU","description":"Skill_description__dRSSN"};